import type { FC, ReactNode, SVGProps } from 'react';

export default function DetailRow({
  icon: Icon,
  label,
  value,
}: {
  icon?: FC<SVGProps<SVGSVGElement>>;
  label?: string;
  value: string | ReactNode;
}) {
  return (
    <div className="flex items-center gap-2">
      {Icon && <Icon className="size-6 shrink-0 fill-muted-foreground" aria-hidden="true" />}
      {label && <dt className="text-sm font-semibold text-foreground">{label}:</dt>}
      <dd className="text-sm font-normal text-foreground">{value}</dd>
    </div>
  );
}
